module.exports = __webpack_public_path__ + "img/1696398880090-nib mirna yunia.jpg.cb6aa1cd.webp";